import {
  get_questions_mounted_course,
  post_questions_course,
  delete_questions_course,
  post_answer_course,
  put_questions_course,
  delete_answer_course
} from "../../../api/repositories/questions";

export default {
  async get_questions_course({ commit }, { _body }) {
    try {
      const response = await get_questions_mounted_course(_body);
      commit("SET_QUESTIONS_COURSE", response);
    } catch (error) {
      // commit("SET_HANDLE_ESTATUS_ERROR", error);
    }
  },
  async post_questions_course({ commit }, { _body }) {
    try {
      commit("SET_LOADDING", true);
      const response = await post_questions_course(_body);
      commit("SET_LOADDING", false);
    } catch (error) {
      // commit("SET_HANDLE_ESTATUS_ERROR", error);
    }
  },
  async put_questions_course({ commit }, { _body }) {
    try {
      commit("SET_LOADDING", true);
      const response = await put_questions_course(_body);
      commit("SET_QUESTIONS_COURSE", response);
      commit("SET_LOADDING", false);
    } catch (error) {
      // commit("SET_HANDLE_ESTATUS_ERROR", error);
    }
  },
  async post_answer_course({ commit }, { _body }) {
    try {
      commit("SET_LOADDING", true);
      const response = await post_answer_course(_body);
      commit("SET_QUESTIONS_COURSE", response);
      commit("SET_LOADDING", false);
    } catch (error) {
      // commit("SET_HANDLE_ESTATUS_ERROR", error);
    }
  },
  async delete_questions_course({ commit }, { _question_id }) {
    try {
      const response = await delete_questions_course(_question_id);
      commit("SET_QUESTIONS_COURSE", response);
    } catch (error) {
      // commit("SET_HANDLE_ESTATUS_ERROR", error);
    }
  },
  async delete_answer_course({ commit }, { _answer_id }) {
    try {
      const response = await delete_answer_course(_answer_id);
      commit("SET_QUESTIONS_COURSE", response);
    } catch (error) {
      // commit("SET_HANDLE_ESTATUS_ERROR", error);
    }
  },
};
